import { render, staticRenderFns } from "./CheckpointPastVersionCard.vue?vue&type=template&id=473bc3b6&scoped=true"
import script from "./CheckpointPastVersionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointPastVersionCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointPastVersionCard.vue?vue&type=style&index=0&id=473bc3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473bc3b6",
  null
  
)

export default component.exports